<script setup lang="js">

import {ref} from "vue";
import Context from "@/components/Context.vue";
import ContextColors from "@/components/ContextColors.vue";
const jcjmk = ref("https://cos5.51tgqj.com/techming/img/jcjmk@2x.png");
const zlzcstq = ref("https://cos5.51tgqj.com/techming/img/zlzcstq@2x.png");
const hxjzzz = ref("https://cos5.51tgqj.com/techming/img/hxjzzz@2x.png");
const xhs = ref("https://cos5.51tgqj.com/techming/img/xqs@2x.png");
const jsk = ref("https://cos5.51tgqj.com/techming/img/jsk@2x.png");
// const hxjzzz = "https://cos5.51tgqj.com/techming/img/hxjzzz@2x.png";

</script>

<template>
  <div>
    <context-colors color="bg-[#86DCFC]" class="flex justify-center text-center">
      <el-image :src="jcjmk" class="w-2/3"/>
    </context-colors>
    <context>
      <div class="flex justify-center text-center">
        <el-image :src="zlzcstq" class="w-2/3 md:w-2/3 lg:w-1/3"/>
      </div>
    </context>
    <context>
      <div class="flex justify-center text-center ">
        <el-image :src="hxjzzz" class="w-2/3 md:w-2/3 lg:w-1/3"/>
      </div>
    </context>
    <context>
      <div class="flex justify-center text-center ">
        <el-image :src="xhs" class="w-2/3 md:w-2/3 lg:w-1/3"/>
      </div>
    </context>
    <context>
      <div class="flex justify-center text-center">
        <div class="text-black text-3xl md:text-3xl lg:text-4xl bg-[#74E0C1] px-4 py-1 rounded-full">服 务 理 念</div>
      </div>
      <div class="flex justify-center text-center mt-5">
        <div class="text-[#FD6610] text-3xl md:text-3xl lg:text-[1.8rem]">以“就业创业”为核心引擎</div>
      </div>
      <div class="flex justify-center text-center mt-5 md:mt-5 lg:mt-9">
        <p class="text-white text-3xl md:text-3xl lg:text-[1.8rem] leading-loose ">构建“就业创业/健康管理/心理服务/生活配套/教育培训/文化惠民/数字赋能”社区“</p>
      </div>
    </context>
    <context class="">
      <div class="flex justify-center text-center items-center">
        <div class="w-3/5 flex justify-center items-center ">
          <el-image :src="jsk" class="w-full"/>
          <div class="absolute text-white text-3xl md:text-3xl lg:text-[1.8rem] flex flex-col justify-center ">
            <div class="">项目引入：聚焦差异化优势</div>
            <div class="lg:mt-8 md:mt-4">人员策略：推进本地化就业</div>
            <div class="lg:mt-8 md:mt-4">运营管理：强化统一性规范</div>
            <div class="lg:mt-8 md:mt-4">品牌塑造：构建平台化体系</div>
          </div>
        </div>
      </div>

    </context>
  </div>
</template>

<style scoped>

</style>
